import Button from "./Button";

export default class SoundButton extends Button {
	private _muteCallback: () => any;
	private _muteCallbackContext: any;

	constructor(
		scene: Phaser.Scene,
		x: number,
		y: number,
		texture: string,
		muteCallback?: () => any,
		muteCallbackContext?: CallbackContext
	) {
		super(scene, x, y, texture, null, () => {
			scene.sound.mute = !scene.sound.mute;
		});

		this._muteCallback = muteCallback;
		this._muteCallbackContext = muteCallbackContext;

		scene.sound.on(Phaser.Sound.Events.GLOBAL_MUTE, this.onMuted, this);
		scene.events.once(
			Phaser.Scenes.Events.UPDATE,
			() => {
				this.onMuted(scene.sound.mute);
			},
			this
		);
	}

	private onMuted(muted: boolean): void {
		this._muteCallback.bind(this._muteCallbackContext)(muted);
	}

	destroy(): void {
		if (this.scene != null) this.scene.sound.off(Phaser.Sound.Events.GLOBAL_MUTE, this.onMuted, this);
		super.destroy();
	}
}
